import { Calculator, FloppyDisk, Lightning, Warning, ClipboardText } from "@phosphor-icons/react";
import { formatRupiah } from "../../lib/format";

export default function ProposalCard({ proposal, onSendToCalculator, onSaveToHistory }) {
  const tindakan = proposal.tindakan || [];
  const extraTotal = tindakan.reduce(
    (s, t) => s + (t.biaya_tambahan || []).reduce((a, b) => a + (Number(b.nominal) || 0), 0),
    0,
  );
  return (
    <div
      className="mt-3 border border-violet-200 bg-violet-50/60 rounded-lg p-4"
      data-testid="proposal-card"
    >
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-violet-700 flex items-center gap-1.5">
            <ClipboardText size={14} weight="duotone" /> Usulan Estimasi AI
          </div>
          <div className="text-sm font-semibold text-slate-900 mt-0.5">{proposal.ringkasan}</div>
          <div className="text-xs text-slate-600 mt-1 flex gap-3 flex-wrap">
            <span>Kelas: <b>{proposal.kelas}</b></span>
            <span>Penjamin: <b>{proposal.penjamin === "BPJSTK" ? "BPJSTK" : "Umum / Asuransi"}</b></span>
            <span>Tipe: <b>{proposal.operation_type || "ELEKTIF"}</b></span>
          </div>
        </div>
      </div>

      <div className="mt-3 flex flex-col gap-2">
        {tindakan.map((t, i) => (
          <div key={i} className="bg-white border border-slate-200 rounded p-3 text-xs" data-testid={`proposal-tindakan-${i + 1}`}>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-bold text-slate-900 text-sm">
                {i + 1}. {t.nama_tindakan || t.kategori}
              </span>
              <span className="text-slate-500">· {t.kategori}</span>
              {t.cito && (
                <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-bold bg-red-50 text-red-600 border border-red-200">
                  <Lightning size={10} weight="fill" /> CITO
                </span>
              )}
              {t.penyulit && (
                <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-bold bg-amber-50 text-amber-700 border border-amber-200">
                  <Warning size={10} weight="fill" /> PENYULIT
                </span>
              )}
              {t.multiplet && <span className="text-slate-600 font-semibold">{t.multiplet}</span>}
            </div>
            <div className="text-slate-600 mt-1 flex gap-3 flex-wrap">
              <span>Asisten: {t.include_asisten ? "Ya" : "Tidak"}</span>
              <span>Sewa Alat Khusus: {t.include_sewa_alat_khusus ? "Ya" : "Tidak"}</span>
              {t.manajemen_nyeri > 0 && <span>Manajemen Nyeri: {formatRupiah(t.manajemen_nyeri)}</span>}
              {t.obat_bhp_ok > 0 && <span>Obat &amp; BHP OK: {formatRupiah(t.obat_bhp_ok)}</span>}
            </div>
            {(t.biaya_tambahan || []).length > 0 && (
              <ul className="mt-2 space-y-0.5">
                {t.biaya_tambahan.map((b, k) => (
                  <li key={k} className="flex justify-between border-t border-dashed border-slate-200 pt-1">
                    <span className="text-slate-700">+ {b.nama}</span>
                    <span className="tabular-nums font-semibold">{formatRupiah(b.nominal)}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {(proposal.catatan || []).length > 0 && (
        <ul className="mt-3 text-[11px] text-slate-600 list-disc pl-4 space-y-0.5">
          {proposal.catatan.map((c, i) => (
            <li key={i}>{c}</li>
          ))}
        </ul>
      )}

      <div className="mt-3 flex items-center justify-between gap-3 flex-wrap">
        <div className="text-xs text-slate-600">
          {extraTotal > 0 ? (
            <>Biaya tambahan: <b className="tabular-nums">{formatRupiah(extraTotal)}</b> · </>
          ) : null}
          Tarif komponen master dihitung resmi oleh Kalkulator.
        </div>
        <div className="flex gap-2 flex-wrap">
          <button
            onClick={onSendToCalculator}
            className="bg-[#0A3F9A] text-white px-3 py-2 rounded hover:bg-[#082F73] text-xs font-bold inline-flex items-center gap-1.5"
            data-testid="proposal-send-to-calculator"
          >
            <Calculator size={14} weight="duotone" /> Kirim ke Kalkulator
          </button>
          <button
            onClick={onSaveToHistory}
            className="bg-[#057A55] text-white px-3 py-2 rounded hover:bg-[#046148] text-xs font-bold inline-flex items-center gap-1.5"
            data-testid="proposal-save-to-history"
          >
            <FloppyDisk size={14} weight="duotone" /> Simpan ke Riwayat
          </button>
        </div>
      </div>
    </div>
  );
}
